import React from 'react';
import { SelectionListItemScheme } from '../../../../Base/Components/SelectionList/SelectionListItem';
import SelectionList from '../../../../Base/Components/SelectionList/SelectionList';
import { LaboratoryTemplateType } from '../../../Enums/LaboratoryTemplateType.enum';

interface Props {
	onClick: (type: LaboratoryTemplateType) => void;
}

const OPTIONS: SelectionListItemScheme[] = [
	{
		id: LaboratoryTemplateType.WORKPLACE,
		name: 'component.laboratoryRequestTemplateTypeSelection.workplaceTemplate.title',
		description:
			'component.laboratoryRequestTemplateTypeSelection.workplaceTemplate.description',
	},
	{
		id: LaboratoryTemplateType.DOCTOR,
		name: 'component.laboratoryRequestTemplateTypeSelection.personalTemplate.title',
		description:
			'component.laboratoryRequestTemplateTypeSelection.personalTemplate.description',
	},
];

const LaboratoryRequestTemplateTypeSelection: React.FC<Props> = ({
	onClick,
}) => {
	const onItemClick = (item: SelectionListItemScheme) => {
		onClick(item.id as LaboratoryTemplateType);
	};

	return (
		<SelectionList
			data={OPTIONS}
			onItemClick={onItemClick}
			buttonLabel='component.laboratoryRequestTemplateTypeSelection.selectButton'
		/>
	);
};

export default LaboratoryRequestTemplateTypeSelection;
